module.exports = __webpack_public_path__ + "img/shenqingchaxunfuwutuikuan.182b6b4b.png";